import { Locale } from "@/i18n/config";
import { usePathname, useRouter } from "@/i18n/navigation";
import { setUserLocale } from "@/services/locale";
import { Check } from "lucide-react";
import { useLocale } from "next-intl";
import Image from "next/image";
import { useTransition } from "react";
import { GateLoader } from "../GateLoader/GateLoader";
import { useSearchParams } from "next/navigation";

type Props = {
  label: string;
  locale: Locale;
  noSelector?: boolean;
};

const flags = {
  ["zh-CN"]: "cn",
  ["zh-TW"]: "cn",
  en: "gb",
} as const;

export const LangItem = ({ label, locale, noSelector = false }: Props) => {
  const [isPending, startTransition] = useTransition();
  const currentLocale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  function onChangeLocale() {
    startTransition(() => {
      setUserLocale(locale);

      // Preserve all query parameters
      const query = searchParams.toString();
      const urlWithParams = query ? `${pathname}?${query}` : pathname;

      // ✅ Locale-aware navigation that keeps params
      router.push(urlWithParams, { locale });
    });
  }
  const isSelected = currentLocale === locale;

  return (
    <button
      type="button"
      onClick={onChangeLocale}
      className="flex gap-2 p-2 items-center justify-between w-full rounded-none font-switzer text-base font-semibold"
      disabled={isSelected}
    >
      <span className="flex gap-2 items-center">
        <Image
          src={`/assets/v2/icons/flags/${flags[locale]}.svg`}
          height={20}
          alt="icon"
          width={20}
        />
        <span>{label}</span>
      </span>
      {!noSelector && !isPending && isSelected && (
        <Check className="text-sleap-purple-300 block" />
      )}
      {isPending && <GateLoader />}
    </button>
  );
};
